module.exports = __webpack_public_path__ + "static/media/circle-chevron-left.7565e9da.svg";